<template>
  <div class="content">
    <el-input :disabled="!isEdit" maxlength="4" placeholder="0"  v-model="hour"></el-input>
    <div class="text">小时</div>
    <el-input :disabled="!isEdit"  placeholder="0"  v-model="minutes" maxlength="2" ></el-input>
    <div class="text">分钟</div>
  </div>
</template>
<script>
export default {
  props: {
    time: {
      type: Number,
      default: 0,
    },
    isEdit:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      hour: '',
      minutes: '',
    };
  },
  created() {
    this.hour = parseInt(this.time / 60);
    this.minutes = parseInt(this.time % 60);
    console.log('小时', this.hour);
    console.log('分钟', this.minutes);
  },
  watch: {
    time(){
      if(this.time){
        this.hour = parseInt(this.time / 60);
        this.minutes = parseInt(this.time % 60);
      }else{
        this.hour = '';
        this.minutes = '';
      }
        
    },
    hour(val) {
      val+=""
      this.$nextTick(() => {
        val = val.replace(/^(0+)|[^\d]+/g, '');
        this.hour = val;
        this.$emit('update', {
          hour: this.hour,
          minutes: this.minutes,
        });
        console.log('小时', this.hour);
      });
    },
    minutes(val1) {
      val1 += '';
      this.$nextTick(() => {
        console.log('val', val1);
        val1 =String(val1).replace(/^(0+)|[^\d]+/g, '');
        if (val1 > 59) {
          this.minutes = 59;
          //   e.detail.value = 59;
          this.$emit('update', {
            hour: this.hour,
            minutes: this.minutes,
          });
        }else if(!val1){
           this.minutes ='';
          this.$emit('update', {
            hour: this.hour,
            minutes: this.minutes,
          });
        } 
        else if (val1 <= 0) {
          this.minutes = 0;
          this.$emit('update', {
            hour: this.hour,
            minutes: this.minutes,
          });
        } else {
          this.minutes = val1;
          this.$emit('update', {
            hour: this.hour,
            minutes: this.minutes,
          });
        }
      });
    },
    computed: {
      hourComputed: {
        get() {
          this.hour = parseInt(this.time / 60);
          return parseInt(this.time / 60);
        },
      },
      minutesComputed: {
        get() {
          this.minutes = parseInt(this.time % 60);
          return parseInt(this.time % 60);
        },
      },
    },
    methods: {},
  },
};
</script>
<style scoped>
.input {
  width: 80px;
  height: 32px;
  margin-right: 10px;
  border: 1px solid #bfbfbf;
  text-align: center;
}
.content {
  display: flex;
  justify-content: space-around;
  /* align-items: center; */
}
.text {
  margin-right: 10px;
  font-size: 14px;
  color: #bfbfbf;
  display: inline-block;
  min-width: 30px;
  margin-left: 10px;
  /* font-weight: 500; */
}
</style>
